import { combineReducers } from 'redux';
import user from './user';
import apiKey from './apiKey';
import balances from './balances';
import transactions from './transactions';
import recipients from './recipients';
import crossBorder from './crossBorder';
import config from './config';
import exchangeRate from './exchangeRate';

export default combineReducers({
  user,
  apiKey,
  balances,
  transactions,
  recipients,
  crossBorder,
  config,
  exchangeRate,
});

//
